import type { NavigationItem } from "@app/types/Navigation";
import { sectionNavigationItems } from "@util/constant";

const navigationItems: NavigationItem[] = [
  { ...sectionNavigationItems["companies-markets"], label: "COMPANIES" },
  { ...sectionNavigationItems.property, label: "PROPERTY" },
  { ...sectionNavigationItems["startups-tech"], label: "STARTUPS" },
  { ...sectionNavigationItems["opinion-features"], label: "OPINION" },
  { ...sectionNavigationItems.lifestyle, label: "LIFESTYLE" },
  { ...sectionNavigationItems.podcasts, label: "PODCASTS" },
  { ...sectionNavigationItems.epaper, label: "E-PAPER" },
];

export { navigationItems };
